import React from 'react';
import styles from './Performance.module.css';

interface LLMAXComponent extends React.FC {
  title?: string;
}

const LLMAX: LLMAXComponent = () => {
  return (
    <div>
      <p className={styles.warningText}>
        Spend and OMNI ROAS metrics will not show data for January - March 2024, data is only available after the program start date, April 2nd 2024.
      </p>
      
      <h2 className={styles.title}>Metric Descriptions</h2>
      
      <div>
        <div className={styles.metricSection}>
          <strong>OMNI Revenue</strong>
          <p>
            Consists of total acehardware.com revenue for your store plus total Google paid search sales tracked for your store.
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>Store Visits</strong>
          <p>
            Count of customers who interacted with a Google ad and visited your store.
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>Spend</strong>
          <p>
            Amount of your Local Lift Max investment spent during the period
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>OMNI ROAS</strong>
          <p>
            Omni revenue divided by spend
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>Local Lift Max Investment</strong>
          <p>
            Your total Local Lift Max investment for the current year.
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>On acehardware.com ecommerce</strong>
          <p>
            To qualify for the $8 Revenue on Ad Spend Guarantee, you must be active on acehardware.com for the year. If your store needs to be turned on acehardware.com ecommerce, please contact the Care Center.
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>On In Store Pick</strong>
          <p>
            To qualify for the $8 Revenue on Ad Spend Guarantee, you must participate in In Store Pick for the year. To learn more and sign-up for ISP, visit{' '}
            <a 
              href="https://www.surveymonkey.com/r/ISPUAgreement" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.link}
            >
              https://www.surveymonkey.com/r/ISPUAgreement
            </a>
          </p>
        </div>

        <div className={styles.metricSection}>
          <strong>Google Business Profile</strong>
          <p>
            To qualify for the $8 Revenue on Ad Spend Guarantee, you must grant Ace access to your Google Business Profile by adding acehardwarestore@gmail.com as an &quot;Owner&quot;. If you have questions or need to know how to add a user, please contact GMBRequests@acehardware.com.
          </p>
        </div>
      </div>
    </div>
  );
};

LLMAX.title = 'Local Lift Max';
export default LLMAX;
